import React , {useState , useRef , useEffect}from 'react';
import Navbar from '../Navbar/Navbar';
import './Header.scss';
import Logo from '../Logo/Logo';
import { throttle } from "lodash";
import Auth from '../Auth/Auth';
import { BurgerMenu } from '../MobileMenu';
const Header=(props)=>{
    const [isOpen, setIsOpen] = useState(false);
  const handleSetIsOpen = () => {
    setIsOpen(!isOpen);
  };
  const wrapperRef = useRef(null); 
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
     removeBar();
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);
  function removeBar(){
    setIsOpen(false);
  }
  let classes = [];
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = throttle(() => {
      if (window.scrollY >= 20) setScrolled(true);
      else setScrolled(false);
    }, 100);
    window.addEventListener("scroll", handleScroll);
 return () => {
      window.removeEventListener("scroll", handleScroll);
    }
  }, []);
if (scrolled) classes.push("scrolled");
  else classes.push(props.styles);
  const prevScrollY = useRef(0);
const [goingUp, setGoingUp] = useState(false);
 function classChange(){
   if(window.scrollY <= 100){
     setGoingUp(false);
   }
 }
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (prevScrollY.current < currentScrollY || window.scrollY < 50  ) {
        setGoingUp(false);
      }
      if (prevScrollY.current > currentScrollY && !goingUp && window.scrollY > 50  ) {
        setGoingUp(true);
      }
    prevScrollY.current = currentScrollY;
  };
window.addEventListener("scroll", handleScroll, { passive: true });
return () => window.removeEventListener("scroll", handleScroll);
  }, [goingUp]);
    return(
        <header className={`header   ${props.styles} ${goingUp === false && `header`} ${goingUp === true && `scrolled`}`}>
             <div className="header_container">

            <Logo scrolled={scrolled || props.styles === "scrolled"  } />
            <Navbar />
            <Auth />
            <BurgerMenu />
             </div>
        </header>
    )
};
export default Header ;